import { Link } from "react-router-dom";
import { Play } from "lucide-react";

export default function GameCard({ game, playing = 0, className = "", style }) {
  const Icon = game.icon;
  return (
    <Link to={`/games/${game.slug}`} className={`game-tile group ${className}`} data-testid={`game-card-${game.slug}`} style={{ "--accent": game.accent, ...style }}>
      <div className="tile-media">
        <img src={game.image} alt={game.name} className="cover" loading="lazy" />
        <div className="tile-shade" />
        {game.badge && (
          <span className="absolute top-2.5 left-2.5 chip text-[9px] py-0.5 px-2" style={{ color: game.accent, borderColor: `${game.accent}66`, background: "rgba(10,10,10,0.7)" }}>
            {game.badge}
          </span>
        )}
        <div className="tile-play">
          <span className="tile-play-btn"><Play size={22} fill="currentColor" /></span>
        </div>
        <div className="absolute bottom-3 left-3 right-3">
          <div className="text-[9px] uppercase tracking-[0.2em] text-zinc-400 flex items-center gap-1.5"><Icon size={10} style={{ color: game.accent }} /> FMI Originals</div>
          <div className="font-display font-black text-lg tracking-tight leading-tight mt-0.5">{game.name}</div>
        </div>
      </div>
      <div className="flex items-center justify-between px-3 py-2.5 text-[11px]">
        <span className="flex items-center gap-1.5 text-zinc-400"><span className="live-dot" /> <span className="font-mono-num text-zinc-300" data-testid={`playing-${game.slug}`}>{playing}</span> playing</span>
        <span className="font-mono-num text-zinc-500">RTP {game.rtp}%</span>
      </div>
    </Link>
  );
}
